import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SignpostIcon(props: IconProps) {
    return <Icon {...props} iconKey={"signpost"}/>
}
